import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../../../../assets/img/fayvenDashImage.png';
import {
  CustomTab,
  Image,
  Layout,
  Loading,
  TabPanel,
  TabsContainer,
  UserNavbar,
} from '../../../../components';
import VendorApplications from './components/VendorApplications';
import { getEventById, onChangeEventManagerTab } from '../../../../core/events/action';
import ManageVendors from './components/ManageVendors';
import RefundAplication from './components/RefundAplication';

function EventManagement() {
  const { eventId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { event, loading: eventsLoading, manageEventTab } = useSelector((store) => store.events);
  const { loading: vendorEventsLoading } = useSelector((store) => store.vendorEvents);
  const { loading: balanceLoading } = useSelector((store) => store.balance);

  const [selectedTabIndex, setSelectedTabIndex] = useState(!!manageEventTab && 0);

  useEffect(() => {
    setSelectedTabIndex(manageEventTab);

    dispatch(getEventById(eventId));
  }, [dispatch, eventId]);

  return (
    <Layout>
      {(eventsLoading || vendorEventsLoading || balanceLoading) && <Loading />}
      <UserNavbar />
      <Image src={Banner} alt="" className="dashboard__banner" />
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12} textAlign="center">
          <TabsContainer
            variant="fullWidth"
            value={selectedTabIndex}
            onChange={(_, newValue) => {
              dispatch(onChangeEventManagerTab(newValue));
              setSelectedTabIndex(newValue);
            }}>
            <CustomTab label="Manage Vendors" />
            <CustomTab label="Applications" />
            <CustomTab label="Refunds" />
          </TabsContainer>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          my={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative">
          <Box position="absolute" left={0}>
            <IconButton onClick={() => navigate(-1)}>
              <ChevronLeft sx={{ fill: '#0997ba', width: '1.5em', height: '1.5em' }} />{' '}
            </IconButton>
          </Box>
          <Typography variant="h4" color="#EE7B57" fontWeight="bold">
            {event?.name}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <TabPanel value={selectedTabIndex} index={0}>
            <ManageVendors event={event} />
          </TabPanel>
          <TabPanel value={selectedTabIndex} index={1}>
            <VendorApplications event={event} />
          </TabPanel>
          <TabPanel value={selectedTabIndex} index={2}>
            <RefundAplication event={event} />
          </TabPanel>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default EventManagement;
